module.exports = __webpack_public_path__ + "static/media/builtinv2-podkluchenie 2.f94641f7.png";